module.exports = __webpack_public_path__ + "static/img/2.2becac3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/17/eng/2.png
// module id = F4mq
// module chunks = 0